import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const homeApi = createApi({
  reducerPath: 'homeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['User'],
  endpoints: (builder) => ({
    // Get user information
    getUserInfo: builder.query({
      query: (userId) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/user-info',
          method: 'POST',
          params: { 'access-token': token, id: userId },
        };
      },
      transformResponse: (response) => {
        if (response?.status === 1) {
          return response.data?.[0] || null;
        }
        return null;
      },
      providesTags: ['User'],
    }),
    // Update user profile
    updateProfile: builder.mutation({
      query: (formData) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/profile',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUserInfoQuery,
  useUpdateProfileMutation,
} = homeApi;